import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FileDown, Loader2 } from "lucide-react";

const months = Array.from({ length: 12 }, (_, i) => {
  const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - i);
  return { v: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`, l: d.toLocaleDateString("ar-SA-u-nu-latn-ca-gregory", { month: "long", year: "numeric" }) };
});

export function StatementDownload() {
  const [m, setM] = useState(months[0].v);
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get("/my/statement", { params: { month: m }, responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(res.data); a.download = `statement-${m}.pdf`; a.click();
      URL.revokeObjectURL(a.href);
    } catch { toast.error("تعذر تنزيل كشف الحساب"); }
    setBusy(false);
  };
  return (
    <div className="flex items-center gap-2" data-testid="statement-download">
      <Select value={m} onValueChange={setM}>
        <SelectTrigger className="w-40 h-9" data-testid="statement-month-select"><SelectValue /></SelectTrigger>
        <SelectContent>{months.map((x) => <SelectItem key={x.v} value={x.v} data-testid={`statement-month-${x.v}`}>{x.l}</SelectItem>)}</SelectContent>
      </Select>
      <Button size="sm" variant="outline" className="rounded-full gap-1" disabled={busy} onClick={download} data-testid="statement-download-btn">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />} كشف حساب PDF
      </Button>
    </div>
  );
}
